import { z } from 'zod';
// Canonical source of the numerals (digit-system) preference — the single guest
// list the wire contracts validate against (ADR-030; the ADR-009 single-source
// rule, same pattern as LanguageSchema).
//
// Numerals is the ONE user-overridable formatting axis (ADR-030). It is its own
// preference because digit system is orthogonal to language: a Saudi user can
// want an Arabic UI with Western digits.
//   · 'auto'  → policy default: Arabic-Indic (٠١٢٣) for `ar`, Western (0123)
//               otherwise. Resolving at render time (not freezing per row) means
//               a future policy change moves every 'auto' user with no migration.
//   · 'latin' → force Western digits everywhere (the Arabic-UI-Western-digits case).
// Technical values (E.164 phone, IDs, keys) force Western at the call site
// regardless of this preference.
//
// The DATABASE mirrors this set in a CHECK constraint — keep in sync when adding
// a value:
//   backend/migrations/000_baseline_schema.sql · chk_users_numerals
// (SQL can't import this module; the migration comment points back here.)
export const NUMERALS = ['auto', 'latin'];
export const NumeralsSchema = z.enum(NUMERALS);
